$(function () {
    if ($(window).width() > 992) {
        $(".twolglinkAnim").mouseenter(function () {
            $(this).find('.twolglinkAnimShow').slideDown(300);
            $(this).find('.twolglinkAnimHide').slideUp(300);
        })
        $(".twolglinkAnim").mouseleave(function () {
            $(this).find('.twolglinkAnimShow').slideUp(300);
            $(this).find('.twolglinkAnimHide').slideDown(300);
        });
        $(".twolglinkAnim").focusin(function () {
            $(this).find('.twolglinkAnimShow').slideDown(300);
            $(this).find('.twolglinkAnimHide').slideUp(300);
        })
        $(".twolglinkAnim").focusout(function () {
            $(this).find('.twolglinkAnimShow').slideUp(300);
            $(this).find('.twolglinkAnimHide').slideDown(300);
        });
    }
});